import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { AddDspaceStatisticsComponent } from '../../../dspace-statistics/components/add-dspace-statistics/add-dspace-statistics.component';
import { EmergencyCallsService } from '../../services/emergency-calls-service';
import { AddEmergencyCallsComponent } from '../add-emergency-calls/add-emergency-calls.component';
import { PagingService } from '../../../../shared/Services/PagingService';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'app-get-emergency-calls',
  templateUrl: './get-emergency-calls.component.html',
  styleUrls: ['./get-emergency-calls.component.scss']
})


export class GetEmergencyCallsComponent extends BaseComponent implements OnInit {
  dateTo: string;
  dateFrom: string;
  form: FormGroup;
  constructor(
    public service: EmergencyCallsService,
    route: Router,
    private fb: FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private paging: PagingService
  ) {
    super(route, service, paging, '', diag);
  }

  ngOnInit() {
    this.loadEntities();
  }

  addNew() {
    this.dialog
      .open(AddEmergencyCallsComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddEmergencyCallsComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}

